import { render, staticRenderFns } from "./TermsAndConditionsLink.vue?vue&type=template&id=828b0df8&"
import script from "./TermsAndConditionsLink.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports